<template>
    <section v-if="callAction != ''" class="calltoaction-wrapper cta-bg-img">
      <img :src="$imgURL + callAction[0].insInstitucionalImagens[0].itgUrlImagem" alt="">

      <div class="container">
         <div class="row align-items-center">
            <div class="col-lg-8 col-md-12">
               <div class="calltoaction-caption">
                  <h2>{{ callAction[0].itiNome }}</h2>
               </div>
            </div>
            <div v-if="whatsapp && whatsapp.length > 0" class="col-lg-4 col-md-12 text-lg-right calltoaction-btn">
               <a :href="whatsapp[0].itiReferencia" class="btn_cta_white" target="_blank">
                  <i class="fa fa-whatsapp"></i> {{ whatsapp[0].itiNome }}
               </a>               
            </div>

         </div>
      </div>
   </section>

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageCallAction',

  data: () => ({
    callAction: [],
    whatsapp: [],
  }),

  methods: {
    
  },

  created() {

    // CALL TO ACTION
    axios.get('/Process/InsInstitucional/institucional/58/callaction/0/x')
      .then(response => {
        this.callAction = response.data;
        //console.log('callaction')
        //console.log(this.callAction)
      })
      .catch(error => {
        console.error(error);
      });

    // WHATSAPP
    axios.get('/Process/InsInstitucional/institucional/9/whatsapp/0/x')
      .then(response => {
        this.whatsapp = response.data;
        //console.log('whatsapp')
        //console.log(this.whatsapp)
      })
      .catch(error => {
        console.error(error);
      });
  }
};
</script>